<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xkevGy/tc-custom/9780547630441.jpg?1708658260245" alt="This image is the cover for the book Old and New Poems"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Old and New Poems
      </h1>
      <p class="bookDescription body article font2">
        <b>This collection drawn from more than forty years of the poet’s work is “a superb introduction to newcomers and a sumptuous offering to familiars” (<i>Publishers Weekly</i>).</b><br/><br/>Former US Poet Laureate Donald Hall has been celebrated with numerous awards, including the National Book Critics Circle Award and the National Medal of the Arts.<br/><br/>This volume collects some of Hall’s finest short poetry written between 1947 and 1990. Here are poems of landscape and love, of dedication and prophecy.<br/><br/><b>“Our delight is in following an exceptional poet's growth and depth as he emerges with a richly playful but consummately serious voice.” —<i>Publishers Weekly</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Donald Hall
      </h2>
      
      <p class="authorDescription body article">DONALD HALL, poet laureate of the United States from 2006 to 2007, has received the National Book Critics Circle Award, the Los Angeles Times Book Prize in poetry, the Lenore Marshall Award, the 1990 Frost Medal from the Poetry Society of America, and the Ruth Lilly Poetry Prize. He is a member of the American Academy of Arts and Letters.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?76f6e744